import type { Quiz, QuizQuestion } from '@efdigital/ll-addon-data';
import { type TemplateOnlyComponent } from '@ember/component/template-only';

import EditorCard from './editor-card.gts';
import { EditQuizQuestionMarkdown } from './editors/question/shared/edit-quiz-question-markdown.gts';
import { ReportingEditorComponent } from './editors/reporting/reporting.gts';
import type { QuestionManager } from './types/question-manager.ts';
import type { EditingMode } from './utils.ts';

const QuestionEditorCards: TemplateOnlyComponent<{
  Args: {
    question: QuizQuestion;
    index: number;
    manager: QuestionManager;
    quiz: Quiz;
    isEditingMode: (index: number, mode: EditingMode) => boolean;
  };
}> = <template>
  {{#if (@isEditingMode @index "markdown")}}
    <EditorCard @questionType={{@question.type}} @editorType="markdown">
      <div class="card-body">
        <EditQuizQuestionMarkdown @question={{@question}} />
      </div>
    </EditorCard>
  {{else if (@isEditingMode @index "question")}}
    <EditorCard @questionType={{@question.type}} @editorType="question">
      <@manager.questionComponent
        @quiz={{@quiz}}
        @question={{@question}}
        @index={{@index}}
      />
    </EditorCard>
  {{else if (@isEditingMode @index "scoring")}}
    <EditorCard @questionType={{@question.type}} @editorType="scoring">
      {{#if @manager.scoringComponent}}
        <@manager.scoringComponent @question={{@question}} @quiz={{@quiz}} />
      {{else}}
        <p class="card-text">
          Scoring not supported for this question type.
        </p>
      {{/if}}
    </EditorCard>
  {{else if (@isEditingMode @index "response")}}
    <EditorCard @questionType={{@question.type}} @editorType="response">
      {{#if @manager.responseComponent}}
        <@manager.responseComponent @question={{@question}} @quiz={{@quiz}} />
      {{else}}
        <p class="card-text">
          Responses not supported for this question type.
        </p>
      {{/if}}
    </EditorCard>
  {{else if (@isEditingMode @index "reporting")}}
    <EditorCard @questionType={{@question.type}} @editorType="reporting">
      <ReportingEditorComponent @question={{@question}} @quiz={{@quiz}} />
    </EditorCard>
  {{/if}}
</template>;

export default QuestionEditorCards;
